import React, { useEffect, useRef } from 'react';
import { Check } from 'lucide-react';

const ModuleCard = ({ icon, title, description, features, delay = 0 }) => {
    const cardRef = useRef(null);

    useEffect(() => {
        if (cardRef.current) {
            cardRef.current.style.transitionDelay = `${delay}s`;
        }
    }, [delay]);

    return (
        <div
            ref={cardRef}
            className="bg-white p-6 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg"
        >
            <div className="flex items-center mb-4">
                <div className="p-3 bg-primary-100 rounded-lg">
                    {React.cloneElement(icon, { className: "text-primary-600" })}
                </div>
                <h3 className="text-xl font-semibold ml-4">
                    {title}
                </h3>
            </div>
            <p className="text-gray-600 mb-6">
                {description}
            </p>
            <ul className="space-y-2">
                {features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                        <Check size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                        <span>{feature}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ModuleCard;